import { render } from "./calculator_fr.vue?vue&type=template&id=a3001402"
import script from "./calculator_fr.vue?vue&type=script&lang=js"
export * from "./calculator_fr.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/project/wp-content/themes/resource-database/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__